import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class SeedPolicyService {
    constructor(api) {
        this.api = api;
    }

    async get() {
        try {
            const response = await withRetry(() => this.api.get(), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to load seed policy');
        }
    }

    async update(data = {}) {
        try {
            const response = await this.api.update(data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to update seed policy');
        }
    }

    async listTombstones() {
        try {
            const response = await withRetry(() => this.api.listTombstones(), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to list seed tombstones');
        }
    }

    async createTombstone(data = {}) {
        try {
            const response = await this.api.createTombstone(data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to create seed tombstone');
        }
    }

    async deleteTombstone(id) {
        try {
            const response = await this.api.deleteTombstone(id);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete seed tombstone');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
